import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 bg-brand-dark/50 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-lg flex flex-col max-h-[95vh] animate-in fade-in zoom-in-95 duration-200">
        <div className="px-4 sm:px-6 py-4 border-b border-gray-100 flex justify-between items-center shrink-0">
          <h3 className="text-lg font-semibold text-brand-dark truncate pr-2">{title}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-brand-alert transition-colors p-1">
            <SafeIcon icon={FiIcons.FiX} className="text-xl" />
          </button>
        </div>
        <div className="p-4 sm:p-6 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;